import styled from 'styled-components'
import {
  WHITE,
  WHITE_SMOKE,
  GRAY_HEADER,
  GRAY_ANTDESIGN,
  GRAY_DARK,
  BLUE_SKY,
  BLUE_SKY_LIGHT,
  RED_DARK,
} from '../../../theme/colors'
import AntdProgress from 'antd/lib/progress'

const DARK_TEXT = '#302628'
const BORDER_SIDEBAR = '#D7D1D2'

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  min-height: 728px;
  background: ${WHITE};
  border: 1px solid #bcbcbc;
  border-radius: 5px;
  max-width: 1500px;
  font-family: "Avenir Next";
  margin-bottom: 36px;
`

export const Sidebar = styled.div`
  max-width: 458px;
  background: ${GRAY_HEADER};
  border: 1px solid ${BORDER_SIDEBAR};
  padding: 28px;
  .anticon:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  .product-info {
    margin-top: 40px;
    display: flex;
    align-items: center;
    color: ${DARK_TEXT};
    font-size: 22px;
    i {
      margin-left: 8px;
    }
    div {
      span {
        :first-child {
          margin-right: 4px;
          font-weight: 500;
        }
        :last-child {
          font-weight: 600;
        }
      }
    }
  }

  button.upload-button {
    margin-top: 40px;
    width: 100%;
    height: 44px;
    border-radius: 22px;
    background: ${DARK_TEXT};
    color: ${WHITE};
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    :hover {
      cursor: pointer;
      background: ${WHITE};
      color: ${DARK_TEXT};
    }
  }

  .uploaded-file {
    margin-top: 40px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: ${GRAY_DARK};
    #fileName {
      max-width: 212px;
      overflow-x: hidden;
      white-space: nowrap;
      padding-right: 2px;
    }
    span {
      text-align: center;
      font-size: 14px;
      font-style: italic;
      font-weight: 500;
    }
    div {
      display: flex;
      align-items: center;
      height: 33px;
      margin-left: 8px;
      padding-inline: 12px;
      border-radius: 100px;
      border: 1px solid ${GRAY_ANTDESIGN};
      background: ${WHITE_SMOKE};
      span {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.15px;
      }
      i {
        margin-left: 10px;
        color: ${RED_DARK};
        cursor: pointer;
        display: block;
      }
    }
  }

  .config {
    margin-top: 40px;
    display: flex;
    padding-bottom: 8px;
    flex-direction: column;
    border-radius: 6px;
    border: 1px solid ${BORDER_SIDEBAR};
    background: ${WHITE};
  }

  .footnote {
    margin-top: 40px;
    font-size: 16px;
    line-height: 22px;
    div:first-child {
      span {
        :first-child {
          margin-right: 4px;
          color: ${DARK_TEXT};
          font-weight: 600;
        }
        :last-child {
          font-weight: 400;
        }
      }
    }
    .action-text {
      margin-top: 40px;
      span {
        :first-child {
          color: ${BLUE_SKY};
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          text-decoration: underline;
          margin-right: 4px;
          cursor: pointer;
        }
      }
    }
  }
  #configTitle {
    font-size: 20px;
    font-weight: bold;
    font-family: Avenir;
    border-bottom: 1px solid #D7D1D2;
    margin: 16px 32px 0;
    padding-bottom: 8px;
  }
  .colorList {
    height: fit-content !important;
  }
`

export const ProTip = styled.div`
  display: flex;
  width: 400px;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid ${BLUE_SKY};
  background: ${BLUE_SKY_LIGHT};
  padding: 20px 16px;
  margin-top: 1px;
  div {
    margin-left: 8px;
    span {
      :first-child {
        font-weight: 600;
        margin-right: 8px;
      }
      :last-child {
        font-weight: 400;
      }
    }
  }
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  #twoViewCont {
    position: absolute;
    top: 62px;
    z-index: 2;
    background: white;
    padding: 12px 32px;
    width: 100%;
    height: calc(100% - 62px);
    text-align: center;
  }
  #twoViewImg {
    width: 100%;
    object-fit: contain;
    height: 100%;
  }
  #threeDBtn {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    border: 1px solid #D7D1D2;
    border-radius: 25px;
    background: white;
    z-index: 2;
    font-weight: 500;
    font-family: Avenir;
    cursor: pointer;
    padding: 8px 14px;
    align-items: center;
    :hover {
      background: #d8d8d8;
    }
  }
  #threeDIco {
    max-width: 22px;
    margin-right: 10px;
  }
`

export const FloatingBtns = styled.div`
  position: absolute;
  top: 20px;
  display: flex;
  border: 1px solid #D7D1D2;
  border-radius: 25px;
  background: white;
  z-index: 2;
  font-weight: 500;
  font-family: Avenir;
  overflow: hidden;
  cursor: pointer;
  & > div {
    padding: 10px 14px;
    &[data-enabled="true"] {
      background: #302628;
      color: white;
    }
  }
`

export const Arrow = styled.div`
  cursor: pointer;
  font-size: 16px;
  margin: 12px 6px 6px 30px;
  color: cornflowerblue;
`

export const ModalUpload = styled.div`
  font-family: Avenir;
  #titleUpload {
    display: flex;
    justify-content: space-between;
    font-size: 22px;
    margin-bottom: 38px;
  }
  #fileSection {
    display: flex;
    flex-flow: column;
    align-items: center;
    color: #302628;
  }
  .anticon-file-image {
    font-size: 40px;
    color: #B3B3B3;
    margin-block: 20px 12px;
  }
  label {
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    cursor: pointer;
  }
  #termsCheck {
    width: 24px;
    height: 24px;
    margin-inline: 4px 12px;
  }
  #terms {
    cursor: pointer;
    color: cornflowerblue;
  }
  .btnAction {
    width: 50%;
    border: 1px solid #302628;
    color: #302628;
    padding: 8px;
    border-radius: 25px;
    text-align: center;
    font-weight: 500;
    transition: background .25s, color .25s;
    :hover {
      cursor: pointer;
      background: #302628;
      color: white;
    }
  }
  #uploadBtn {
    margin-left: 26px;
    background: #302628;
    color: white;
    :hover {
      color: #302628;
      background: white;
    }
    &[data-disabled="true"] {
      background-color: #cccccc;
      color: #666666;
      cursor: not-allowed;
      opacity: 0.7;
      pointer-events: none;
      border-color: #cccccc;
    }
  }
  .ant-spin {
    height: 17px;
  }
`

export const PreviewProgress = styled(AntdProgress)`
  width: 400px
  margin-top: -8px;
  .ant-progress-inner {
    background: white;
    box-shadow: 0px 1px 4px -2px gray;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/PreviewAndDesignTemplate/styledComponents.tsx